import React from "react";
import { Loader2 } from "lucide-react";
import { POST } from "@/constants/testIds";

/**
 * Bottom action bar with legal microcopy and the submit CTA. Kept as its
 * own file so the primary CTA button stays trivially locatable when we
 * A/B-test copy or add secondary "Save draft" flows.
 */
export default function SubmitBar({ isEdit, submitting, disabled, label }) {
  // Iter-283 fix (iteration_110): only `submitting` uses the native
  // `disabled` attribute (double-submit lock). A soft `disabled` prop
  // (e.g. incomplete checklist) uses aria-disabled + visual style so
  // pressing Enter still reaches the form's onSubmit handler and can
  // surface the "please tick all boxes" toast to keyboard users.
  const softDisabled = disabled && !submitting;
  return (
    <div className="pt-4 border-t border-subtle flex items-center justify-between gap-4">
      <button
        type="submit"
        data-testid={POST.submit}
        disabled={submitting}
        aria-disabled={softDisabled || undefined}
        className={`inline-flex items-center gap-2 rounded px-6 py-2.5 bg-red-500 hover:bg-red-600 text-white font-bold shadow-card transition-colors ${
          submitting || softDisabled ? "opacity-70" : ""
        } ${softDisabled ? "cursor-not-allowed" : ""}`}
      >
        {submitting && <Loader2 className="w-4 h-4 animate-spin" />}{" "}
        {label || (isEdit ? "Save Changes" : "Post Now")}
      </button>
      <div className="text-xs text-slate-500 text-right">
        By {isEdit ? "saving" : "posting"} you agree to our marketplace guidelines.
      </div>
    </div>
  );
}
